import { ClipboardCheck, FileText, BarChart3, Activity, MessageSquare } from "lucide-react";
import type { AiReportType } from "@/api/reports/reportApi";

/**
 * Конфигурация типов отчётов
 * Используется в TrustIndexSection и других компонентах
 */
export interface ReportTypeConfig {
  type: AiReportType;
  labelKey: string;
  icon: React.ComponentType<{ className?: string }>;
  color: string;
}

/**
 * Конфигурация всех типов отчётов для индекса доверия
 * Порядок определяет приоритет отображения
 */
export const REPORT_TYPE_CONFIGS: Record<AiReportType, ReportTypeConfig> = {
  evaluation: {
    type: "evaluation",
    labelKey: "label-evaluation-report-tab",
    icon: ClipboardCheck,
    color: "#91C000",
  },
  answers: {
    type: "answers",
    labelKey: "label-answers-report-tab",
    icon: FileText,
    color: "#91C000",
  },
  q_density: {
    type: "q_density",
    labelKey: "label-q-density-report-tab",
    icon: BarChart3,
    color: "#91C000",
  },
  actions: {
    type: "actions",
    labelKey: "label-actions-report-tab",
    icon: Activity,
    color: "#91C000",
  },
  transcribe: {
    type: "transcribe",
    labelKey: "label-transcribe-report-tab",
    icon: MessageSquare,
    color: "#91C000",
  },
};

/**
 * Массив конфигураций в порядке отображения в TrustIndex
 */
export const TRUST_REPORT_TYPES: ReportTypeConfig[] = [
  REPORT_TYPE_CONFIGS.answers,
  REPORT_TYPE_CONFIGS.actions,
  REPORT_TYPE_CONFIGS.transcribe,
];

/**
 * Видимые типы отчётов в зависимости от типа задания.
 * Для external-задания (карточка задания) отчёт "answers" не применим.
 */
export function getTrustReportTypes(assignmentType?: string): ReportTypeConfig[] {
  if (assignmentType === "external") {
    return TRUST_REPORT_TYPES.filter((config) => config.type !== "answers");
  }

  return TRUST_REPORT_TYPES;
}
